import { useTranslation } from '@/lib/i18n/i18n.client';

import { targets } from '@/blocks/Scraper/constants/targets';
import { getTagsFromTargets } from '@/blocks/Scraper/helpers';
import Badge from '@/components/atoms/badge';
import { targetGroupLabels } from '@decodo/utils';

const Tags = ({
  selectedTag,
  setSelectedTag,
}: {
  selectedTag: string;
  setSelectedTag: (tag: string) => void;
}) => {
  const { texts } = useTranslation();

  const tags = getTagsFromTargets(targets).map((tag) => ({
    value: tag,
    label: tag,
  }));

  const finalTags = [
    { value: '', label: texts.feature_library.all_tag },
    ...tags,
  ];

  return (
    <ul className='mb-2 flex w-full flex-1 flex-wrap gap-3'>
      {finalTags.map((tag) => {
        const isSelected = selectedTag === tag.value;

        const target = tag.value
          ? targetGroupLabels[tag.value as keyof typeof targetGroupLabels]
          : texts.feature_library.all_tag;

        return (
          <li key={tag.value} onClick={() => setSelectedTag(tag.value)}>
            <Badge
              color='gray'
              variant={isSelected ? 'filled' : 'soft'}
              onClick={() => setSelectedTag(tag.value)}
              classNames={{
                root: 'text-body-s font-mono cursor-pointer py-[2px] px-3 normal-case',
              }}
            >
              {target}
            </Badge>
          </li>
        );
      })}
    </ul>
  );
};

export default Tags;
